import React, {useEffect, useState} from "react";
import "./PackMan.scss";
import {PackManCurrent} from "./PackManCurrent/PackManCurrent";
import {PackManHistory} from "./PackManHistory/PackManHistory";
import {HomeHeader} from "../../Components";
import {picker_orders} from "../../Services/PackMan/PackManServices";


function PackMan() {

    const [tabIndex,set_tabIndex] = useState(1)
    const [currents,set_currents] = useState([])
    const [history,set_history] = useState([])
    const [merchantId,sest_merchantId] = useState("")


    useEffect(()=>{
        let data= [
            {
                name:"DMI-123434554",
                status:"آماده صدور",
                time:"07:2",
                stack:"accepted",
                date:"۱۳۹۹ تاریخ ۲۹ - ۲۳:۵۹",
                uid:3454
            },
            {
                name:"DMI-123434554",
                status:"آماده صدور",
                time:"07:2",
                stack:"noAccepted",
                date:"۱۳۹۹ تاریخ ۲۹ - ۲۳:۵۹",
                uid:345445656
            },
        ]
        set_currents(data)
        set_history(data)
    },[])



    //get orders
    const getCurrent = async () =>{
        try {
            const response = await picker_orders(merchantId);
            set_currents(response.data);
        }catch (e) {
            console.log(e)
        }
    }


    const changeTab = (index)=>{
        set_tabIndex(index);
    }

    return(
        <div className="packMan-container">
            <HomeHeader/>
            <div className="packMan-body">
                <div className="packMan-tab">
                    <div className={tabIndex===2?"packMan-tab-item active":"packMan-tab-item"}>
                        <span  onClick={()=>{changeTab(2)}}>آرشیو سفارشات</span>
                    </div>
                    <div className={tabIndex===1?"packMan-tab-item active":"packMan-tab-item"}>
                        <span onClick={()=>{changeTab(1)}}>سفارشات جدید</span>
                    </div>
                </div>

                {tabIndex===1?<PackManCurrent data={currents}/>:null}
                {tabIndex===2?<PackManHistory data={history}/>:null}
            </div>
        </div>
    )

}

export {PackMan};
